import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/[locale]/blog/blog.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["BlogCard"] */ "/opt/build/repo/src/components/blog/BlogCard/BlogCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/blog/Pagination.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/ui/Banner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ButtonLink"] */ "/opt/build/repo/src/components/ui/Button/Button.tsx");
